import CreateOffer from "../../features/dashboard/offers/CreateOffer";

function CreateOffersDB() {
    return <CreateOffer />
}

export default CreateOffersDB